import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { ChartsModule } from 'ng2-charts';
import { ScoresChartComponent } from './scores-chart/scores-chart.component';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { FullscreenDirective } from './fullscreen.directive';
import { CarouselComponent } from './carousel/carousel.component';
import { RouterModule } from '@angular/router'; 
import { ProfileComponent } from './profile/profile.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { DataTablesModule } from "angular-datatables";
import { FeedbackComponent } from './header/feedback/feedback.component';

@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    ScoresChartComponent,
    ImageViewerComponent,
    FullscreenDirective,
    CarouselComponent,
    HeaderComponent,
    HomeComponent,
    FeedbackComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    IvyCarouselModule,
    ChartsModule,
    NgxPanZoomModule,
    DataTablesModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
